export enum SuggestTitleEvents {
	GenerateSuggestedTitle = 'editor_ai:start_suggest_a_title',
	ReplaceConfluenceTitle = 'editor_ai:replace_confluence_title',
}
